<script lang="ts">
  import { alerts } from "$stores/alert";
  import { portal } from "$actions/portal.svelte";
  import { fadeSlide } from "$transitions";
  import Alert from "../+blocks/Alert/Alert.svelte";
  import { quartOut } from "svelte/easing";
</script>

<div class="fixed right-0 bottom-2 mx-4" use:portal={{ target: "body", zIndex: "z-alert" }}>
  {#each $alerts as alert (alert.id)}
    <div
      transition:fadeSlide|global={{ duration: 500, easing: quartOut }}
      class="px-1.5 pt-1.5 pb-3"
    >
      <Alert {...alert} on:close={() => alerts.remove(alert.id)} maxWidthClass="max-w-[400px]" />
    </div>
  {/each}
</div>
<slot />
